(function () {
  'use strict';

  var PLACEHOLDER = /\{\{\s*(\w+)\s*\}\}/;

  function withDelimiters(cents, precision, thousands, decimal) {
    if (isNaN(cents) || cents == null) return '0';

    var parts = (cents / 100.0).toFixed(precision).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);

    return parts[1] ? whole + decimal + parts[1] : whole;
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var placeholder = format.match(PLACEHOLDER);
    if (!placeholder) return format;

    var value;
    switch (placeholder[1]) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = withDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_with_space_separator':
        value = withDelimiters(cents, 2, ' ', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = withDelimiters(cents, 0, ' ', ',');
        break;
      case 'amount_with_period_and_space_separator':
        value = withDelimiters(cents, 2, ' ', '.');
        break;
      default:
        value = withDelimiters(cents, 2, ',', '.');
    }

    return format.replace(PLACEHOLDER, value);
  }

  function scopeOf(el) {
    return el.closest('[data-product-scope]') || document;
  }

  function variantsIn(scope) {
    var script = scope.querySelector('[data-product-variants]');
    if (!script) {
      var picker = scope.querySelector('variant-picker [type="application/json"]');
      script = picker || null;
    }
    if (!script) return [];

    if (!script._variants) {
      try {
        script._variants = JSON.parse(script.textContent);
      } catch (error) {
        script._variants = [];
      }
    }

    return script._variants;
  }

  function currentVariant(scope) {
    var input = scope.querySelector('[data-variant-id]');
    if (!input) return null;

    var id = parseInt(input.value, 10);

    return (
      variantsIn(scope).filter(function (variant) {
        return variant.id === id;
      })[0] || null
    );
  }

  function currentPlanId(scope) {
    var input = scope.querySelector('[name="selling_plan"]');
    return input && input.value ? parseInt(input.value, 10) : null;
  }

  function allocationFor(variant, planId) {
    if (!variant || !planId || !variant.selling_plan_allocations) return null;

    return (
      variant.selling_plan_allocations.filter(function (allocation) {
        return allocation.selling_plan_id === planId;
      })[0] || null
    );
  }

  function currentQuantity(scope) {
    var input = scope.querySelector('input[name="quantity"]');
    var quantity = input ? parseInt(input.value, 10) : 1;

    return quantity > 0 ? quantity : 1;
  }

  function refreshBuy(scope) {
    var variant = currentVariant(scope);
    if (!variant) return;

    var allocation = allocationFor(variant, currentPlanId(scope));
    var unitPrice = allocation ? allocation.price : variant.price;

    var priceEl = scope.querySelector('[data-price]');
    var wasEl = scope.querySelector('[data-price-was]');

 
    if (priceEl) {
      if (allocation) {
        if (!priceEl.dataset.oneTimePrice) {
          priceEl.dataset.oneTimePrice = priceEl.textContent.trim();
          priceEl.dataset.oneTimeVariant = String(variant.id);
        }
        priceEl.textContent = formatMoney(unitPrice);
      } else if (priceEl.dataset.oneTimePrice) {
       
        priceEl.textContent =
          priceEl.dataset.oneTimeVariant === String(variant.id)
            ? priceEl.dataset.oneTimePrice
            : formatMoney(variant.price);

        delete priceEl.dataset.oneTimePrice;
        delete priceEl.dataset.oneTimeVariant;
      }
    }

    if (wasEl) {
      var struck = null;
      if (allocation && allocation.price < variant.price) {
        struck = variant.price;
      } else if (!allocation && variant.compare_at_price > variant.price) {
        struck = variant.compare_at_price;
      }

      if (struck) {
        wasEl.textContent = formatMoney(struck);
        wasEl.hidden = false;
      } else {
        wasEl.hidden = true;
      }
    }

    var button = scope.querySelector('[data-add-to-cart]');
    if (!button) return;

    button.disabled = !variant.available;
    button.setAttribute('aria-disabled', String(!variant.available));

    if (!variant.available) {
      button.textContent = button.dataset.soldOutText;
      return;
    }

    var total = formatMoney(unitPrice * currentQuantity(scope));
    button.textContent = button.dataset.addFormat
      ? button.dataset.addFormat.replace('[price]', total)
      : button.dataset.addText;
  }

  document.addEventListener('variant:change', function (event) {
    refreshBuy(scopeOf(event.target));
  });

  var BSUB_INPUTS = '[data-bsub-selling-plan-group-input], [data-bsub-delivery-frequency-option]';

  function onBuyInput(event) {
    var target = event.target;
    if (!target.matches || !target.closest('[data-product-scope]')) return;

    var scope = scopeOf(target);

    
    if (target.matches(BSUB_INPUTS)) {
      setTimeout(function () {
        refreshBuy(scope);
      }, 0);
      return;
    }

    if (!target.matches('input[name="quantity"], [name="selling_plan"]')) return;

    refreshBuy(scope);
  }

  document.addEventListener('change', onBuyInput);
  document.addEventListener('input', onBuyInput);

  class SubscribeToggle extends HTMLElement {
    connectedCallback() {
      this.scope = this.closest('[data-product-scope]') || document;
      this.switch = this.querySelector('[data-subscribe-switch]');
      if (!this.switch) return;

      this.switch.addEventListener('click', this.toggle.bind(this));

   
      this.scope.addEventListener('change', this.onPlanChange.bind(this));

      this.setState(this.hasAttribute('data-default-on'));
    }

    get planInput() {
      return this.scope.querySelector('[data-selling-plan-input]');
    }


    get appWidget() {
      var widget = this.scope.querySelector('[data-bsub-widget]');
      if (!widget) return null;
      return widget.closest('.shopify-app-block') || widget;
    }

    onPlanChange(event) {
      var target = event.target;
      if (!target.matches) return;

      if (target.matches('[data-bsub-selling-plan-group-input]')) {
        this.renderSwitch(!target.hasAttribute('data-bsub-purchase-option-one-time'));
        return;
      }

      if (!target.matches('[data-selling-plan-input]')) return;

      this.renderSwitch(Boolean(target.value));
    }

    
    setAppState(on) {
      var widget = this.appWidget;
      if (!widget) return false;

      widget.hidden = !on;
      if (this.hasAttribute('data-hide-app-options')) widget.classList.add('bsub--options-hidden');

      var freqSelect = this.scope.querySelector('bsub-frequency-select');
      if (freqSelect) freqSelect.hidden = !on;

      var radio = widget.querySelector(
        on
          ? '[data-bsub-selling-plan-group-input]:not([data-bsub-purchase-option-one-time])'
          : '[data-bsub-purchase-option-one-time]'
      );

      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      return true;
    }

    toggle() {
      this.setState(this.switch.getAttribute('aria-checked') !== 'true');
    }

    renderSwitch(on) {
      this.switch.setAttribute('aria-checked', String(on));
      this.switch.classList.toggle('is-on', on);
    }

    setState(on) {
      this.renderSwitch(on);

      if (!this.setAppState(on)) {
        var input = this.planInput;

        if (input) {
          input.value = on ? this.dataset.sellingPlan || '' : '';

          var field = input.closest('[data-selling-plan-field]');
          if (field) {
            var choices = input.tagName === 'SELECT' ? input.options.length : 0;
            field.hidden = !on || choices < 3;
          }
        }
      }

      refreshBuy(this.scope);
    }
  }

  if (!customElements.get('subscribe-toggle')) {
    customElements.define('subscribe-toggle', SubscribeToggle);
  }

  class VariantPicker extends HTMLElement {
    connectedCallback() {
      this.sectionId = this.dataset.section;
      this.productUrl = this.dataset.url;

      this.scope = this.closest('[data-product-scope]') || document;
      this.variants = variantsIn(this.scope);
      this.writeHistory = !this.hasAttribute('data-no-history');

      this.addEventListener('change', this.onChange.bind(this));
    }

    get selectedOptions() {
      return Array.from(this.querySelectorAll('input[type="radio"]:checked, select')).map(function (input) {
        return input.value;
      });
    }

    onChange() {
      var selected = this.selectedOptions;

      var variant = this.variants.find(function (candidate) {
        return candidate.options.every(function (option, index) {
          return option === selected[index];
        });
      });

      this.updateLabels(selected);
      this.updateVariant(variant);
    }

    updateLabels(selected) {
      this.querySelectorAll('[data-option-value]').forEach(function (el, index) {
        el.textContent = selected[index] || '';
      });
    }

    updateVariant(variant) {
      var idInput = this.scope.querySelector('[data-variant-id]');
      var button = this.scope.querySelector('[data-add-to-cart]');
      var priceHost = this.scope.querySelector('[data-price-block]');

      if (!variant) {
        if (button) {
          button.setAttribute('aria-disabled', 'true');
          button.disabled = true;
          button.textContent = button.dataset.unavailableText;
        }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (this.writeHistory) {
        window.history.replaceState({}, '', this.productUrl + '?variant=' + variant.id);
      }

      refreshBuy(this.scope);

      if (priceHost) this.refreshPrice(variant.id, priceHost);

      this.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
    }

    refreshPrice(variantId, host) {
      var scope = this.scope;

      fetch(this.productUrl + '?variant=' + variantId + '&section_id=' + this.sectionId)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var parsed = new DOMParser().parseFromString(html, 'text/html');
          var fresh = parsed.querySelector('[data-price-block]');
          if (!fresh) return;

          host.innerHTML = fresh.innerHTML;
        
          refreshBuy(scope);
        })
        .catch(function () {
        });
    }
  }

  if (!customElements.get('variant-picker')) {
    customElements.define('variant-picker', VariantPicker);
  }

 
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-gallery-track]');
      this.stage = this.querySelector('[data-gallery-stage]');
      this.prevBtn = this.querySelector('[data-gallery-prev]');
      this.nextBtn = this.querySelector('[data-gallery-next]');
      this.currentIndex = 0;

      this.isDragging = false;
      this.dragStartX = 0;
      this.dragDeltaX = 0;
      this.stageWidth = 0;

      this.addEventListener('click', this.onClick.bind(this));
      this.updateNavState();

      if (this.track) {
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onPointerMove = this.onPointerMove.bind(this);
        this.onPointerUp = this.onPointerUp.bind(this);

        this.track.addEventListener('pointerdown', this.onPointerDown);
        this.track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      }
    }

    get items() {
      return this.track ? Array.from(this.track.querySelectorAll('[data-gallery-item]')) : [];
    }

    get thumbs() {
      return Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    }

    onClick(event) {
      if (this.suppressClick) {
        this.suppressClick = false;
        return;
      }

      var thumb = event.target.closest('[data-gallery-thumb]');
      if (thumb) {
        var index = this.items.findIndex(function (item) {
          return item.id === thumb.dataset.galleryThumb;
        });
        if (index !== -1) this.goToIndex(index, false); // direct thumb click -> scroll nahi
        return;
      }

      var nav = event.target.closest('[data-gallery-prev], [data-gallery-next]');
      if (nav && !nav.disabled) {
        var delta = nav.hasAttribute('data-gallery-next') ? 1 : -1;
        this.goToIndex(this.currentIndex + delta, true); // arrow click -> thumb scroll ho
      }
    }

    onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      if (!this.items.length) return;

      this.isDragging = true;
      this.dragStartX = event.clientX;
      this.dragDeltaX = 0;
      this.stageWidth = this.stage ? this.stage.getBoundingClientRect().width : this.track.getBoundingClientRect().width;

      this.track.classList.add('is-dragging');
      this.track.style.transition = 'none';

      this.track.setPointerCapture(event.pointerId);

      this.track.addEventListener('pointermove', this.onPointerMove);
      this.track.addEventListener('pointerup', this.onPointerUp);
      this.track.addEventListener('pointercancel', this.onPointerUp);
    }

    onPointerMove(event) {
      if (!this.isDragging || !this.stageWidth) return;

      this.dragDeltaX = event.clientX - this.dragStartX;

      var basePercent = -(this.currentIndex * 100);
      var dragPercent = (this.dragDeltaX / this.stageWidth) * 100;

      var atStart = this.currentIndex === 0 && this.dragDeltaX > 0;
      var atEnd = this.currentIndex === this.items.length - 1 && this.dragDeltaX < 0;
      if (atStart || atEnd) dragPercent *= 0.35;

      this.track.style.transform = 'translateX(' + (basePercent + dragPercent) + '%)';
    }

    onPointerUp(event) {
      if (!this.isDragging) return;
      this.isDragging = false;

      this.track.classList.remove('is-dragging');
      this.track.style.transition = '';
      this.track.releasePointerCapture(event.pointerId);
      this.track.removeEventListener('pointermove', this.onPointerMove);
      this.track.removeEventListener('pointerup', this.onPointerUp);
      this.track.removeEventListener('pointercancel', this.onPointerUp);

      var threshold = this.stageWidth * 0.18; 
      var moved = Math.abs(this.dragDeltaX) > threshold;

      if (moved) {
        this.suppressClick = true;
        var direction = this.dragDeltaX < 0 ? 1 : -1;
        this.goToIndex(this.currentIndex + direction, true);
      } else {
        this.goToIndex(this.currentIndex, true);
      }

      this.dragDeltaX = 0;
    }

    goToIndex(index, scrollThumb) {
      var items = this.items;
      var clamped = Math.max(0, Math.min(index, items.length - 1));
      if (!this.track || !items[clamped]) return;

      this.currentIndex = clamped;
      this.track.style.transform = 'translateX(-' + (clamped * 100) + '%)';

      var activeId = items[clamped].id;
      var activeThumb = null;

      this.thumbs.forEach(function (thumbEl) {
        var isActive = thumbEl.dataset.galleryThumb === activeId;
        thumbEl.classList.toggle('is-active', isActive);
        thumbEl.setAttribute('aria-current', String(isActive));
        if (isActive) activeThumb = thumbEl;
      });

      if (scrollThumb && activeThumb) {
        this.scrollThumbIntoView(activeThumb);
      }

      this.updateNavState();
    }

    scrollThumbIntoView(thumbEl) {
      var container = thumbEl.closest('.pdp__thumbs');
      if (!container) return;

      var containerRect = container.getBoundingClientRect();
      var thumbRect = thumbEl.getBoundingClientRect();

      var thumbCenter = thumbRect.left + thumbRect.width / 2;
      var containerCenter = containerRect.left + containerRect.width / 2;
      var delta = thumbCenter - containerCenter;

      container.scrollBy({ left: delta, behavior: 'smooth' });
    }

    updateNavState() {
      var lastIndex = this.items.length - 1;
      if (this.prevBtn) this.prevBtn.disabled = this.currentIndex <= 0;
      if (this.nextBtn) this.nextBtn.disabled = this.currentIndex >= lastIndex;
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.url || this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      fetch(this.dataset.url)
        .then(function (response) {
          return response.text();
        })
        .then(
          function (html) {
            var parsed = new DOMParser().parseFromString(html, 'text/html');
            var fresh = parsed.querySelector('product-recommendations');
            if (!fresh || !fresh.querySelector('[data-recommendation-item]')) return;

            this.innerHTML = fresh.innerHTML;
            if (window.Duncan) window.Duncan.initReveals(this);
          }.bind(this)
        )
        .catch(function () {
         
        });
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }
})();

class BsubFrequencySelect extends HTMLElement {
  connectedCallback() {
    this.scope = this.closest('[data-product-scope]') || document;
    this.widget = this.scope.querySelector('[data-bsub-widget]');
    this.select = this.querySelector('[data-bsub-select]');
    if (!this.widget || !this.select) return;

    this.build();
    this.select.addEventListener('change', this.onChange.bind(this));

    this.widget.addEventListener('change', this.syncFromNative.bind(this));

    this.widget.hidden = true;
  }

  get oneTimeInput() {
    return this.widget.querySelector('[data-bsub-purchase-option-one-time]');
  }

  get frequencyInputs() {
    return Array.from(this.widget.querySelectorAll('[data-bsub-delivery-frequency-option]'));
  }

  get subscribeGroupInput() {
    return this.widget.querySelector(
      '[data-bsub-selling-plan-group-input]:not([data-bsub-purchase-option-one-time])'
    );
  }

  labelFor(input, isOneTime) {
    var label = input.closest('label');
    var text = label && label.querySelector(isOneTime ? '.bsub-widget__text' : '.bsub-widget__main-text');
    return text ? text.textContent.trim().split('\n')[0].trim() : input.value;
  }

  build() {
    this.select.innerHTML = '';
    this.items = [];

    var oneTime = this.oneTimeInput;
    if (oneTime) this.items.push({ input: oneTime, isOneTime: true });

    this.frequencyInputs.forEach((input) => {
      this.items.push({ input: input, isOneTime: false });
    });

    this.items.forEach((item, index) => {
      var option = document.createElement('option');
      option.value = String(index);
      option.textContent = this.labelFor(item.input, item.isOneTime);
      this.select.appendChild(option);
    });

    this.syncFromNative();
  }

  onChange() {
    var item = this.items[Number(this.select.value)];
    if (!item) return;

    if (!item.isOneTime) this.check(this.subscribeGroupInput);
    this.check(item.input);
  }

  check(input) {
    if (!input || input.checked) return;
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  syncFromNative() {
    var index = this.items.findIndex(function (item) {
      return item.input.checked;
    });
    if (index > -1) this.select.value = String(index);
  }
}

if (!customElements.get('bsub-frequency-select')) {
  customElements.define('bsub-frequency-select', BsubFrequencySelect);
}